<template>
  <owa-modal-frame
    :is-showing="isShowing"
    :has-sections="false"
    title="Use a Kit!"
    component-class="upsell"
    @close-modal="$emit('close-modal')"
  >
    <p class="line-length-xl margin-bottom-xl">
      <span class="size-lg">
        <font-awesome-icon
          :icon="$v7.solid.faToolbox"
          class="margin-right-5xs"
        />
        The easiest way to use icons on your website is with a <strong>Kit</strong>. It’s a custom version of Font Awesome bundled with only the icons, tools,
        and settings you need.
      </span>
    </p>

    <div
      class="message margin-bottom-sm margin-top-md tablet:padding-x-2xl tablet:padding-y-xl laptop:padding-x-5xl laptop:padding-y-3xl"
      style="--message-background: var(--fa-lt-gravy); --link-color: var(--fa-dk-gravy); --link-hover-color: var(--fa-blue)"
    >
      <start-form :has-arrived-from-figma="false" />
    </div>

    <button
      type="button"
      class="flat link block text-right margin-top-md padding-bottom-0"
      @click="handleDownloadClick"
    >
      Never mind. Continue with downloading Font Awesome Free
      <font-awesome-icon :icon="$v7.solid.faArrowRight" />
    </button>
  </owa-modal-frame>
</template>

<script>
  import StartForm from 'app/views/start/components/StartForm'

  export default {
    name: 'ModalUseKit',

    components: {
      StartForm
    },

    props: {
      isShowing: {
        type: Boolean,
        required: true
      },

      on: {
        type: String,
        default: ''
      },

      release: {
        type: Object,
        default: () => ({})
      }
    },

    methods: {
      handleDownloadClick() {
        this.$emit('downloadFree', { on: this.on, release: this.release })
      }
    }
  }
</script>
